import { useTranslation } from '@framework/i18n';
import {
  SearchableField,
  SearchableFieldGroup,
  SearchableFieldType,
} from '@framework/ui';

export function useObservationSearchableFields() {
  const { t } = useTranslation();

  const searchableFields: SearchableField[] = [
    {
      type: SearchableFieldType.Text,
      label: t('observation.titolo-domanda', 'Titolo Domanda'),
      name: 'titoloTipoDomanda',
      placeholder: t('observation.titolo-domanda', 'Titolo Domanda'),
      group: SearchableFieldGroup.Filters,
    },
    // {
    //   type: SearchableFieldType.Text,
    //   label: t('observation.numero-procedimento', 'Numero Procedimento'),
    //   name: 'numeroProcedimento',
    //   placeholder: t(
    //     'observation.numero-procedimento',
    //     'Numero Procedimento',
    //   ),
    //   group: SearchableFieldGroup.Filters,
    // },
    {
      type: SearchableFieldType.Text,
      label: t('observation.oggetto-procedimento', 'Oggetto Procedimento'),
      name: 'oggettoProcedimento',
      placeholder: t(
        'observation.oggetto-procedimento',
        'Oggetto Procedimento',
      ),
      group: SearchableFieldGroup.Filters,
    },
    {
      type: SearchableFieldType.Text,
      label: t('observation.Cognome-titolare', 'Cognome Titolare'),
      name: 'cognomeTitolare',
      placeholder: t('observation.Cognome-titolare', 'Cognome Titolare'),
      group: SearchableFieldGroup.Filters,
    },
  ];

  return searchableFields;
}
